import Resume from "./Resume"

export default function Blog() {
    return (
        <>
            
            <Resume />
        </>
    )
}
